import StandarLayout from '@components/Layouts/StandarLayout';
import ProjectIdPage from '@pages/projects/id/indext';
// eslint-disable-next-line import/named
import { RouteObject } from 'react-router-dom';

const projectRoutes: RouteObject[] = [
  {
    path: '/projects',
    element: <div>Projects List</div>
  },
  {
    path: '/projects/:id',
    element: (
      <StandarLayout>
        <ProjectIdPage />
      </StandarLayout>
    )
  }
];

export default projectRoutes;
